// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { MAX_PRODUCTS_TO_COMPARE } from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";
import {
    chain,
    SetProductIdsParameter,
} from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/LoadProductsToCompare";

export const XngSetProductIdsParameter: typeof SetProductIdsParameter = props => {
    props.apiParameter = {
        productIds: props.parameter.productIds,
        pageSize: MAX_PRODUCTS_TO_COMPARE,
        // XNG-Changes: expanding properties
        expand: ["images", "badges", "properties"],
    };
};

replaceInChain(chain, SetProductIdsParameter, XngSetProductIdsParameter);
